import { render, staticRenderFns } from "./companyList.vue?vue&type=template&id=31abf3d1&scoped=true&"
import script from "./companyList.vue?vue&type=script&lang=js&"
export * from "./companyList.vue?vue&type=script&lang=js&"
import style0 from "./companyList.vue?vue&type=style&index=0&id=31abf3d1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31abf3d1",
  null
  
)

export default component.exports